<template>
  <v-app id="inspire">
    <v-dialog v-model="roleError.status" persistent max-width="500px">
      <v-card>
        <v-card-title>Usuário não possui papel</v-card-title>
        <v-card-text>
          O usuário selecionado não possui papel, por favor entrar em contato com
          o admnistrador do sistema.
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" flat @click="logout">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 30 min de on-line -->
    <v-dialog v-model="dialogOnline" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <h2>Você está ai?</h2>
          <v-spacer></v-spacer>
          </v-card-title>
        <v-card-text>
          Você está mais de 30 minutos logado no sistema. Confirme se ainda esta operante no sistema.
          O sistema efetuará o logoff em {{countDown}} segundos. Clique abaixo para continuar no sistema.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="closeLogoff()">Estou aqui!</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog de Feedback -->
    <v-dialog v-model="feed" persistent max-width="700px">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <h2>FeedBack</h2>
          <v-spacer></v-spacer>
          </v-card-title>
        <v-card-text>
          A sua opinião é muito importante! 
          Por favor nos envie sugestões, críticas ou nos informe se algo não está funcionando.
        </v-card-text>
        <v-card-text>
          <v-flex xs12>
            <v-textarea
              box
              name="feed"
              v-model="feedComentary"
              counter="800"
              maxlength="800"
              label="Comentário"
            ></v-textarea>
          </v-flex>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click.prevent="sendFeed()">Enviar</v-btn>
          <v-btn color="orange darken-1" flat @click="feed = false">Fechar</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog de troca de papel -->
    <v-dialog v-model="chooseRole" max-width="500px">
      <v-card>
        <v-card-title>Selecione o papel</v-card-title>
        <v-card-text>
          <v-select
            :items="$store.state.user.groups"
            v-model="roleSelection"
            label="Select"
            item-text="name"
            single-line
            return-object
            bottom
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="roleSelected()">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog da troca de senha  -->
    <v-dialog v-model="changePass" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <h2>Deseja trocar sua senha ?</h2>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" @submit.prevent="eventSaved">
            <v-text-field
              label="Senha anterior"
              v-model="oldpass"
              hint="Digite sua senha anterior"
              type="password"
              :rules="[v => !!v || 'Senha anterior é obrigatório']"
              required
            ></v-text-field>
            <v-text-field
              label="Nova senha"
              v-model="newpass"
              type="password"
              hint="Digite sua nova senha"
              :rules="[v => !!v || 'Senha nova é obrigatório']"
              required
            ></v-text-field>
            <v-text-field
              label="Confirme a nova senha"
              v-model="confirmpass"
              type="password"
              hint="Repita sua nova senha"
              :rules="[v => !!v || 'Confirmação é obrigatório']"
              required
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="orange darken-1" v-if="!$store.state.user.nextloginreset" flat @click.native="fechar">Fechar</v-btn>
          <v-btn color="orange darken-1" flat @click.prevent="eventSaved">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showPassReset" max-width="500px">
      <v-card>
        <v-card-title>Dialog 2</v-card-title>
        <v-card-text>
          <v-btn color="primary" dark>Open Dialog 3</v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat>Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-navigation-drawer
      fixed
      :clipped="$vuetify.breakpoint.mdAndUp"
      mobile-break-point="960"
      app
      v-model="drawer"
    >
      <v-list dense>
        <v-list-tile class="py-3" @click="$router.push('/usuarios/' + currentUser)">
          <v-avatar :size="40" color="grey lighten-4">
            <img :src="userImage" @error="userImageOnError()" ref="lateral" alt="">
          </v-avatar>
          <div class="ml-3 my-0 py-0">
            <p class="title pt-3 pb-0 my-0">{{currentUser}}</p>
            <p class="pb-0 mt-0 pt-0 caption">{{currentRole}}</p>
          </div>
        </v-list-tile>
        <v-divider></v-divider>
        <template v-for="item in items" 
        v-if="!(isMakerlab && item.mm_only )">
          <v-layout row v-if="item.heading" align-center :key="item.heading">
            <v-flex xs6>
              <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
            </v-flex>
            <v-flex xs6 class="text-xs-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-flex>
          </v-layout>
          <v-list-group
            v-else-if="item.children && !(isMakerlab && item.mm_only )"
            v-model="item.model"
            :key="item.text"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon
          >
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>{{ item.text }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <!-- children -->
            <v-list-tile
              v-for="(child, i) in item.children"
              :key="i"
              v-if="(hasPermissions(child.requires) || $store.state.user.is_superuser === true) && !(isMakerlab && child.mm_only )"
              @click="$router.push({name: child.link})"
            >
              <v-list-tile-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ child.text }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
          <v-list-tile v-else :key="item.text" @click="$router.push(item.link)">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.text }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>

      <div class="mx-4 caption" style="position:absolute; bottom: 5px;">
        <span class="mx-3 caption">{{version}} &copy; MundoMaker 2020</span>
      </div>
    </v-navigation-drawer>
    <v-toolbar
      color="orange"
      dark
      app
      :clipped-left="$vuetify.breakpoint.mdAndUp"
      fixed
      style="z-index: 5"
    >
      <v-toolbar-side-icon class="ml-3" @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title class="ml-0 pl-0">
        <span class="hidden-sm-and-down">
          <v-btn
            flat
            @click="$router.push('/')"
            class="ml-0 pl-0"
            style="height: 80px; width: 80%;"
          >
            <img src="/static/images/MM/marca_mm-07.png" class="ml-1 pl-0" style="height: 80px">
          </v-btn>
        </span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!--
      <div class="mr-2 "> Olá, <span class='ml-2'> </span> {{currentUser}} </div>
      -->
    <div style="margin-right: 10px" v-if="showAlert > 0">
      <v-badge left color="red">
        <span slot="badge">{{showAlert}}</span>
          <v-icon style="margin-left: -10px" 
           @click="goTo()">notifications</v-icon>
      </v-badge>
      </div>
      <v-menu offset-y transition="slide-y-transition">
        <v-btn fab slot="activator" style="width:50px; height: 50px;" color="white" class="pa-0">
          <v-avatar size="44px" class="ma-0 pa-0" color="white">
            <img class="ma-0 pa-0" :src="userImage" @error="userImageOnErrorAba()" ref="logo" alt="Menu">
          </v-avatar>
        </v-btn>
        <v-list>
          <v-list-tile @click="chooseRole=true">
            <v-list-tile-title>Mudar Papel</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="$router.push('/usuarios/' + currentUser)">
            <v-list-tile-title>Editar Perfil</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="changePass=true">
            <v-list-tile-title>Trocar senha</v-list-tile-title>
          </v-list-tile>
          <!-- <v-list-tile @click="feed = true">
            <v-list-tile-title>FeedBack</v-list-tile-title>
          </v-list-tile> -->
          <v-list-tile @click="logout()">
            <v-list-tile-title>Logout</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <v-content>
      <v-container fluid>
        <router-view :key="$route.path" @sino="sino"></router-view>
      </v-container>
    </v-content>
    <v-snackbar v-model="snackbar" bottom :color="cor">
      {{ text }}
      <v-btn flat color="black" @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import api from '@/api';
export default {
  name: 'Dash',
  data: () => ({
    version: 'v1.1',
    countDown: 30,
    dialog: false,
    dialogOnline: false,
    snackbar: false,
    drawer: null,
    stop: null,
    feedComentary: '',
    show: false,
    feed: false,
    showAlert: Number,
    isStudent: false,
    isSecretaria: false,
    roleSelection: null,
    roleError: {
      text:
        'O usuário não possui nenhum papel, contate um funcionário para resolver esse problema',
      status: false
    },
    chooseRole: false,
    menu: false,
    error: '',
    section: 'Dash',
    newpass: '',
    oldpass: '',
    confirmpass: '',
    showPassReset: false,
    changePass: false,
    text: '',
    hasWrongPass: '',
    pwdChanged: false,
    cor: '',
    myitems: [
      {
        icon: 'alarm',
        text: 'Calendário',
        link: this.usrCalendar,
        mm_only: true
      },
      {
        icon: 'keyboard_arrow_up',
        'icon-alt': 'perm_identity',
        text: 'Usuários',
        children: [
          {
            text: 'Cadastro',
            link: 'usuarios-cadastro',
            requires: ['recurrence | param | Can delete param']
          },
          {
            text: 'Busca',
            link: 'usuarios-busca',
            requires: ['atividades | aula | Can change aula']
          }
        ]
      },
      {
        icon: 'keyboard_arrow_up',
        'icon-alt': 'domain',
        text: 'Unidades',
        children: [
          {
            text: 'Cadastro',
            link: 'unidade-cadastro',
            requires: ['apenas | super | user'],
            mm_only: true
          },
          {
            text: 'Buscar',
            link: 'unidades',
            requires: ['atividades | aula | Can change aula']
          }
        ]
      },
      {
        icon: 'keyboard_arrow_up',
        'icon-alt': 'group',
        text: 'Turmas',
        requires: [''],
        children: [
          {
            text: 'Cadastro',
            link: 'turma-cadastro',
            requires: ['recurrence | param | Can delete param']
          },
          {
            text: 'Buscar',
            link: 'turmas'
          }
        ]
      },
      {
        icon: 'keyboard_arrow_up',
        'icon-alt': 'assignment',
        text: 'Programas',
        mm_only: true,
        requires: [''],
        children: [
          {
            text: 'Cadastro',
            link: 'programa-cadastro',
            requires: ['recurrence | param | Can delete param']
          },
          {
            text: 'Buscar',
            link: 'programas',
            requires: ['atividades | aula | Can change aula']
          }
        ]
      },
      {
        icon: 'keyboard_arrow_up',
        'icon-alt': 'school',
        text: 'Projetos',
        requires: ['projects | evidencia | Can add evidencia'],
        secretaria: true,
        children: [
          {
            text: 'Cadastro',
            link: 'projeto-cadastro',
            requires: ['atividades | aula | Can change aula']
          },
          {
            text: 'Buscar',
            link: 'projetos'
          }
        ]
      },
      {
        icon: 'keyboard_arrow_up',
        'icon-alt': 'dvr',
        text: 'Projetos Padrões',
        requires: [''],
        mm_only: true,
        children: [
          {
            text: 'Cadastro',
            link: 'padrao-cadastro',
            requires: ['recurrence | param | Can delete param']
          },
          {
            text: 'Buscar',
            link: 'padroes'
          }
        ]
      },
      {
        icon: 'keyboard_arrow_up',
        'icon-alt': 'account_balance',
        mm_only: true,
        text: 'Empresas',
        children: [
          {
            text: 'Cadastro',
            link: 'empresa-cadastro',
            requires: ['apenas | super | user']
          },
          {
            text: 'Busca',
            link: 'empresas',
            requires: ['apenas | super | user']
          }
        ]
      }
    ]
  }),
  props: {
    source: String
  },
  methods: {
    getToRoute (route) {
      if (route) {
        return { name: route };
      } else {
        return '';
      }
    },
    goTo () {
      this.$store.commit('SET_CENTRAL', 0)
      this.$router.push('/central')
    },
    sino (sinal) {
      this.showAlert = sinal
    },
    countDownTimer () {
      if (this.countDown > 0) {
        this.stop = setTimeout(() => {
          this.countDown -= 1
          this.countDownTimer()
        }, 1000)
      }
    },
    closeLogoff () {
      clearTimeout(this.stop)
      this.dialogOnline = false
    },
    roleSelected () {
      if (this.roleSelection) {
        this.$store.commit('SET_ROLE', this.roleSelection)
        console.log(this.roleSelection)
        this.chooseRole = false;
      }
    },
    hasPermissions (permissions) {
      var hasperm = true;
      if (permissions) {
        if (this.menu) {
          let currentperms = this.$store.state.selectedRole.permissions;
          for (var i in permissions) {
            hasperm = hasperm && currentperms.includes(permissions[i]);
          }
        }
      }
      return hasperm;
    },
    logout () {
      this.$store.commit('LOGOFF');
      this.$router.go('/');
    },
    eventSaved (event) {
      if (this.isEqualForms) {
        if (this.oldpass === this.newpass) {
          this.text = 'A nova senha não pode ser igual a anterior';
          this.cor = 'error';
          this.snackbar = true;
          return;
        }
        let payload = {
          old_password: this.oldpass,
          new_password: this.newpass
        };
        let self = this;
        api
          .request('PUT', 'change-password/', payload)
          .then(function (response) {
            if (response.status === 200) {
              self.pwdChanged = true;
              self.$store.commit('UPDATED_PASSWORD');
              self.cor = 'success';
              self.text = 'Senha alterada com sucesso';
              self.oldpass = '';
              self.newpass = '';
              self.confirmpass = '';
              self.snackbar = true;
              self.changePass = false;
            }
          })
          .catch(function (error) {
            console.log(error);
            this.cor = 'error';
            this.text = 'Parece que a senha atual está incorreta';
            this.snackbar = true;
            this.hasWrongPass = true;
          });
      } else {
        this.cor = 'error';
        this.text = 'Os campos da senha nova estão diferentes';
        this.snackbar = true;
      }
    },
    fechar () {
      this.oldpass = '';
      this.newpass = '';
      this.confirmpass = '';
      this.clear();
      this.changePass = false;
    },
    sendFeed () {
      api.request('POST', 'feedback/', {
        username: this.$store.state.user.username,
        comentary: this.feedComentary
      }).then(data => {
        this.feedComentary = ''
        this.feed = false
        if (data.status === 200) {
          this.cor = 'success';
          this.text = 'Mensagem enviada com sucesso!';
          this.snackbar = true;
        } else {
          this.text = 'A mensagem não pode ser enviada!';
          this.cor = 'error';
          this.snackbar = true;
        }
      })
    },
    areYouHere () {
      this.dialogOnline = true
      this.countDownTimer()
    },
    clear () {
      this.$refs.form.reset();
    },
    userImageOnError () {
      this.onerror = null
      this.$refs.lateral.src = this.$store.state.user.profilePic
    },
    userImageOnErrorAba () {
      this.onerror = null
      this.$refs.logo.src = this.$store.state.user.profilePic
    },
    checkLogin () {
      if (this.$store.state.user.nextloginreset) {
        this.changePass = true
      }
    }
  },
  computed: {
    isMakerlab () {
      return this.$store.state.company.makerlab;
    },
    isMediador () {
      return this.$store.state.selectedRole.name === 'Mediador'
    },
    currentUser () {
      return this.$store.state.user.username;
    },
    items () {
      this.myitems[0].link = this.usrCalendar;
      console.log('items', this.myitems)
      return this.myitems;
    },
    usrCalendar () {
      return '/calendario/usuario/' + this.$store.state.user.username;
    },
    isEqualForms () {
      return this.newpass === this.confirmpass;
    },
    aviso () {
      console.log('aviso', this.$store.state.badge)
      return this.$store.state.badge.reduce((a, b) => a + b, 0)
    },
    currentRole () {
      if (this.$store.state.selectedRole) {
        return this.$store.state.selectedRole.name;
      } else {
        return '';
      }
    },
    userImage () {
      return this.$store.state.user.profilePic_small
    }
  },
  mounted () {
    this.$watch('$store.state.selectedRole.permissions', function () {
      this.menu = true;
    });
    if (this.$store.getters.loginReset) {
      this.showPassReset = true;
    } else {
      if (this.$store.state.user != null) {
        if (this.$store.state.user.groups.length === 1) {
          this.$store.commit('SET_ROLE', this.$store.state.user.groups[0])
          if (this.$store.state.user.groups[0].name === 'Aluno') {
            this.isStudent = true
          }
          if (this.$store.state.user.groups[0].name === 'Secretaria') {
            this.isSecretaria = true
          }
        } else if (this.$store.state.user.groups.length === 0) {
          this.roleError.status = true;
        } else {
          this.chooseRole = true;
        }
      }
    }
    this.checkLogin()
    console.log('store', this.$store.state)
    setInterval(() => {
      this.areYouHere()
      this.countDown = 30
    }, 1800000);

    this.$watch('countDown', function () {
      if (this.countDown === 0) {
        this.logout()
      }
    });
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Dash.vue